module.exports = __webpack_public_path__ + "static/media/FDLogotext.13cddb16.svg";